export enum DiagramItemType {
  UIStepFunction = 'uiStepFunction',
  UIStepFunctionWithRelations = 'uiStepFunctionWithRelations',
  UIDataEvent = 'uiDataEvent',
  UIScheduledDataEvent = 'UIScheduledDataEvent',
  ExclusiveCondition = 'exclusiveCondition'
}
